import React from 'react';
import Avatar from 'material-ui/Avatar'
import {List, ListItem} from 'material-ui/List'
import {Card, CardHeader, CardText} from 'material-ui/Card';
import UserAvatar from './UserAvatar'
import moment from 'moment'
import 'moment/locale/zh-tw'

const styles = {
  detail: {
    marginLeft:56,
    paddingTop:0,
  },
  pre: {
    margin:0,
  }
}


const CommentItem = ({comment:{uid,fbid,name,context,timestamp,video},route}) => {
  let subtitle = route ? route.area +' · ' + route.name +' · ' : ''
  subtitle = subtitle + moment(timestamp).fromNow()
  let videoSrc = video ? 'https://www.youtube.com/embed/'+video.id : null
  return (
    <Card>
      <CardHeader
        title={name}
        subtitle={subtitle}
        avatar={<UserAvatar uid={fbid||uid}/>}
      />
      <CardText style={styles.detail}>
        <pre style={styles.pre}>
        {context}
        </pre>
        {videoSrc && <iframe width="420" height="315"src={videoSrc}/>}
      </CardText>
    </Card>
  )

}

const CommentList = ({list=[],routes}) => {
  return (
    <div>
    {list.map((comment,index)=><CommentItem
                route = {routes && routes[comment.routeId]}
                key={index}
                comment={comment}
                />)}
    </div>
  )

}

export default CommentList


/** WEBPACK FOOTER **
 ** ./src/app/components/CommentList.js
 **/